import { FONT } from "@/styles/common";
import { Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTitle = styled(Text)`
    ${FONT("cormorant", 52, 500)};
`;

export const CustomDescription = {
    TITLE: styled(Text)`
        ${FONT("pretendard", 16, 500)}
    `,
    SUB: styled(Text)`
        ${FONT("pretendard", 14, 300)}
    `,
};
